module.exports = __webpack_public_path__ + "img/termaall.ddb81979.png";